import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  PurchaseOrder,
  PurchaseOrderEntry,
  PurchaseOrderSearch,
  PurchaseOrderStatusCommand,
} from '../../models/order/purchase-order/purchase-order';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { getSkipperErrorHeader } from '../../utils/error-header.util';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/purchase-order';

  public getById(id: string, skipInterceptor = false): Observable<ApiResponse<PurchaseOrder>> {
    const headers = getSkipperErrorHeader(skipInterceptor);
    return this.httpClient.get<ApiResponse<PurchaseOrder>>(`${this.baseUrl}/${id}`, { headers });
  }

  public search(
    searchParams: PurchaseOrderSearch,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
    skipInterceptor = false,
  ): Observable<ApiResponse<PaginatedApiResponse<PurchaseOrder>>> {
    const headers = getSkipperErrorHeader(skipInterceptor);
    let params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder !== undefined) params = params.set('sortOrder', sortOrder.toString());
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<PurchaseOrder>>>(`${this.baseUrl}/search`, searchParams, {
      headers,
      params,
    });
  }

  public create(body: PurchaseOrderEntry): Observable<ApiResponse<PurchaseOrder>> {
    return this.httpClient.post<ApiResponse<PurchaseOrder>>(this.baseUrl, body);
  }

  public update(id: string, body: PurchaseOrder): Observable<ApiResponse<PurchaseOrder>> {
    return this.httpClient.put<ApiResponse<PurchaseOrder>>(`${this.baseUrl}/${id}`, body);
  }

  public updateStatus(id: string, command: PurchaseOrderStatusCommand): Observable<ApiResponse<void>> {
    return this.httpClient.patch<ApiResponse<void>>(`${this.baseUrl}/${id}/status`, command);
  }

  public delete(id: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
